'use strict';

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('react'),
    useState = _require.useState,
    useEffect = _require.useEffect;

function getSize() {
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth
  };
}

function useWindowSize() {
  var _useState = useState(getSize()),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  function handleResize() {
    setWindowSize(getSize());
  }

  useEffect(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}

module.exports = useWindowSize;